import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    defaultOccasion: {
      position: "absolute",
      height: 40,
      right: -10,
      top: -10,
      margin: 0,
      [theme.breakpoints.up("mobile")]: {
        height: 54,
      },
    },
    defaultBirthday: {
      position: "absolute",
      height: 40,
      right: 28,
      top: -12,
      margin: 0,
      [theme.breakpoints.up("mobile")]: {
        right: 43,
        height: 54,
        top: -13,
      },
    },
    imageOccasion: {
      width: 40,
      height: 40,
      [theme.breakpoints.up("mobile")]: {
        width: 54,
        height: 54,
      },
    },
    imageBirthday: {
      width: 28,
      height: 40,
      [theme.breakpoints.up("mobile")]: {
        width: 34,
        height: 54,
      },
    },
  }),
  { name: "Icon" },
);
